module.exports = __webpack_public_path__ + "img/default-header.17e44efd.jpg";